"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitToGridFunctions = void 0;
var fit_to_grid_1 = require("./fit-to-grid");
var fitToGridFunctions = function (gridSize) { return ({
    fitPosToGrid: (0, fit_to_grid_1.fitPosToGridFnGenerator)(gridSize),
    fitVector2dToGrid: (0, fit_to_grid_1.fitVector2dToGridFnGenerator)(gridSize),
    fitRectSizeToGrid: (0, fit_to_grid_1.fitRectSizeToGridFnGenerator)(gridSize),
    fitRectToGrid: (0, fit_to_grid_1.fitRectToGridFnGenerator)(gridSize)
}); };
exports.fitToGridFunctions = fitToGridFunctions;
